
mutation updateUserNotifications($notificationJSON: JSON!, $notificationBoolean: Boolean!) {
    updateUserNotifications(notificationJSON: $notificationJSON, notificationBoolean: $notificationBoolean)
}
